import { AGENT_ALLOCATION_LABELS, AgentAllocationLabel } from '../constants/agentAllocationLabels';
import { AgentAllocation } from '../models/AgentsAllocation';

export const getAgentAllocationLabel = (agent: AgentAllocation): AgentAllocationLabel => {
  if (!agent.defaultRoutingProfile) {
    return AGENT_ALLOCATION_LABELS.UNSET;
  }

  if (agent.routingProfile !== agent.defaultRoutingProfile) {
    return AGENT_ALLOCATION_LABELS.REALLOCATED;
  }

  return AGENT_ALLOCATION_LABELS.DEFAULT;
};

export const getAgentAllocationLabelColor = (label: AgentAllocationLabel): 'grey' | 'red' | 'orange' => {
  if (label === AGENT_ALLOCATION_LABELS.DEFAULT) {
    return 'grey';
  }

  if (label === AGENT_ALLOCATION_LABELS.UNSET) {
    return 'red';
  }

  return 'orange';
};
